/**
 * @file index.tsx
 *
 * @fileoverview Shows an empty box placeholder for the contacts section of organization.
 */
import { FormattedMessage, useIntl } from 'react-intl';
import { OrganizationWidgetsBoxLabel } from '~/jobiqo/components/Organization/Widgets/BoxLabel';
import { OrganizationProfile } from '~/jobiqo/types/types';
import { Box } from '~/vcl/atoms/07-box';
import { UserCheckIcon } from '~/vcl/icons/UserCheck';
import { EmptyElement } from '~/vcl/molecules/02-empty';

export interface OrganizationContactsWidgetEmptyProps {
  /**
   * The current organization profile.
   */
  organization: OrganizationProfile;
  /**
   * The current box id.
   */
  boxId: string | undefined;
}

export const OrganizationContactsWidgetEmpty = ({
  organization,
  boxId,
}: OrganizationContactsWidgetEmptyProps) => {
  const intl = useIntl();

  if (!organization?.canEdit) {
    return null;
  }

  return (
    <Box
      label={
        <OrganizationWidgetsBoxLabel organization={organization} boxId={boxId}>
          {intl.formatMessage({
            id: 'organization_contacts_label',
            defaultMessage: 'Get in touch',
          })}
        </OrganizationWidgetsBoxLabel>
      }
    >
      {!organization?.contactPersons?.length && (
        <div>
          <EmptyElement icon={<UserCheckIcon height="20px" />}>
            <FormattedMessage
              id="organization_contacts_empty"
              defaultMessage="This organization has not added any public contacts."
            />
          </EmptyElement>
        </div>
      )}
    </Box>
  );
};
